import React from 'react';
import { publishButtonMessage } from '../../../lib/PostUtils';

export default function PublishLayerFooter ({ publishing, visibility }) {
  return (
    <div className="layer_foot">
      <div className="wrap_btn">
        <button type='reset' className="btn btn-cancel" disabled={publishing}>
          취소
        </button>
        <button type="submit" className="btn btn-default" disabled={publishing}>
          {publishButtonMessage(publishing, visibility)}
        </button>
      </div>
    </div>
  );
}
